import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { Input1Service } from './input1.service';

@Component({
    selector: 'input1-dialog-component',
    host: { 'class': 'dialog-iframe-content' },
    template: `<div style="height: 100%;overflow-y: hidden">
    <iframe style="width: 100%; height: 100%" [src]="url" title="Input1" allow="payment" allowPaymentRequest>
  </iframe>
</div>`,
    imports: []
})


export class Input1DialogComponent implements OnInit{
  @ViewChild('iframe', {static: false}) iframe: ElementRef;
  
  url: any;
  doc;

    browserMessageHandler: any = this.handleBrowserMessage.bind(this);

  constructor(
    private readonly sanitized: DomSanitizer,
    public dialog: MatDialog,
    public input1Service: Input1Service,
    @Inject(MAT_DIALOG_DATA) public data) {
  }
  ngOnInit(): void {
      if (this.isValidUrl(this.data.link)) {
          this.url = this.sanitized.bypassSecurityTrustResourceUrl(this.data.link);
          window.addEventListener('message', this.browserMessageHandler);
      } else {
          console.error('Invalid URL provided:', this.data.link);
          this.url = null;
      }
  }

  private isValidUrl(url: string): boolean {
      try {
          const urlObj = new URL(url);
          // Only allow http and https protocols
          return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
      } catch {
          return false;
      }
  }

  onLoad(iframe){
      this.doc = iframe.contentDocument || iframe.contentWindow;
  }

    handleBrowserMessage(event: any) {
        if (event?.data == null) { return; }

        try {
            const messageData = event.data;
            if (messageData.messageType !== 'input1Callback') { return; }

            this.handleCallBack(messageData.queryParams);
        } catch (error) {
            // non-json payload, someone else's message
        }
    }
  
    handleCallBack(response: any) {
        this.input1Service.submitCallback(this.data.caseId, this.data.caseIntegrationQueueId, response).subscribe(r => {
            this.dialog.closeAll();
        });
    }
}
